import styled from 'styled-components';
import * as S from '../../SecondaryNav/Styled';
import {
  List as SelecterList,
  Select as SelecterSelect,
  Value as SelecterValue,
  TextInner as SelecterTextInner,
} from '../../Selecter/Styled';
import { Link } from 'react-router-dom';
import cn from 'classnames';

export const Overlay = styled.div`
  background: rgba(50, 61, 76, 0.4);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  opacity: 0;
  display: none;
  transition: var(--transition);

  @media (min-width: 768px) {
    display: none !important;
  }
`;

export const SideNav = styled.div.attrs(({ visible }) => ({
  className: cn({
    'is-visible': visible,
  }),
}))`
  --panel-w: calc(100 * var(--full-vw, 1vw) - 44px);
  width: var(--panel-w);
  height: calc(100 * var(--full-vh, 1vh));
  left: 0;
  top: 0;
  position: fixed;
  background: var(--aluminium10);
  z-index: 1002;
  padding: 12px;
  transform: translateX(calc(-1 * var(--panel-w)));
  transition: var(--transition);

  ${S.List} {
    margin: 0 20px;
  }

  .icon_cart {
    top: -2px;
  }

  @media (min-width: 768px) {
    display: none !important;
  }

  &.is-visible {
    transform: translateX(0);

    + ${Overlay} {
      opacity: 1;
      display: block;
    }
  }
`;

export const MainWrap = styled.div`
  position: absolute;
  top: 52px;
  bottom: 52px;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const BtnContainer = styled.div`
  margin: 0 20px;

  .btn {
    margin: 0 !important;
    width: 100%;
  }
`;

export const StyledLink = styled(Link)`
  padding: 0 20px;
  background: var(--white);
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  letter-spacing: -0.03em;
  box-shadow: 0 -1px var(--aluminium35), 0 1px var(--aluminium35);
  color: var(--carbone100);
  overflow: hidden;

  .icon_user {
    fill: none;
    stroke: var(--blue100);
    stroke-width: 1.5;
  }

  &:hover {
    color: var(--theme-palette-links-secondary-color);

    .icon_heart {
      stroke: var(--theme-palette-links-secondary-color);
    }
  }

  &.auth-link {
    color: var(--blue100);
    font-weight: 600;
  }
`;

export const LocationLink = styled(Link)`
  padding: 0 20px;
  background: var(--white);
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--carbone100);
  font-size: 15px;
  box-shadow: 0 -1px var(--aluminium35), 0 1px var(--aluminium35);

  .icon_location {
    fill: var(--aluminium75);
    top: -0.1em;
    position: relative;
  }

  .icon {
    margin-right: 22px;
  }

  &:hover {
    color: var(--carbone100);
  }
`;

export const City = styled.div`
  position: relative;
  top: -0.1em;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--aluminium35);
`;

export const CloseBtn = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--white);
  padding: 0;
  position: absolute;
  right: 12px;
  top: 12px;
  opacity: 0.6;
  cursor: pointer;
  border: 1px solid var(--grey20);
  border-radius: 50%;
  color: var(--carbone70);
  transition: var(--transition);

  .icon_close {
    left: -0.5px;
    top: -0.5px;
    font-size: 10px;
  }

  &:hover {
    opacity: 1;
  }

  &:focus {
    outline: none;
  }
`;

export const Menu = styled.div`
  padding: 10px 0;
  list-style: none;

  ${StyledLink} {
    font-size: 15px;
  }
`;

export const IconWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 22px;
`;

export const Count = styled.div`
  position: absolute;
  top: -3px;
  right: -7px;
  width: 14px;
  height: 14px;
  background: #f2c94c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--white);
  font-size: 8px;
  font-weight: 600;
  color: var(--black);
`;

export const Label = styled.span`
  position: relative;
  top: -0.1em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const InsuranceSingleWrap = styled.div`
  padding: 10px 20px;
  min-height: 44px;
  overflow: hidden;
`;

export const InsuranceLabel = styled.div`
  font-size: 13px;
  color: var(--carbone100);
  line-height: 1.35;
  word-break: break-word;
`;

export const InsuranceWrap = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 44px;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  .selecter {
    position: static;
    width: 100%;
    min-width: 0;
  }

  ${SelecterSelect} {
    position: static;
    width: 100%;
    min-width: 0;
  }

  ${SelecterValue} {
    width: 100%;
    overflow: hidden;
    min-width: 0;
  }

  ${SelecterTextInner} {
    max-width: none;
    flex: 1;
    min-width: 0;
  }

  ${SelecterList} {
    left: 10px;
    right: 10px;
    width: auto;
    min-width: 0;
    top: 100%;
    bottom: auto;
  }
`;

export const SecondaryNav = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 -1px var(--aluminium35);
`;
